import { render } from "./designNumber.vue?vue&type=template&id=c5d2f972"
import script from "./designNumber.vue?vue&type=script&lang=js"
export * from "./designNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__